import type * as React from "react";
import { Label as LabelPrimitive } from "radix-ui";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "~/lib/utils";

const labelVariants = cva(
  "leading-none group-data-[disabled=true]:opacity-50 peer-disabled:opacity-50 flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none peer-disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        default: "text-sm font-medium",
        muted: "text-xs font-normal text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants>;

function Label({ className, variant = "default", ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(labelVariants({ variant }), className)}
      {...props}
    />
  );
}

/** @knipignore */
export { Label, type LabelProps };
